var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defaultPlugins } from './createDiceRoller';
function withPlugins() {
    var plugins = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        plugins[_i] = arguments[_i];
    }
    var customPlugins = {};
    plugins.forEach(function (plugin) {
        customPlugins[plugin.typeConstant] = plugin;
    });
    // order matters, more specific rules must be dumped in _first_
    var allPlugins = __assign(__assign({}, customPlugins), defaultPlugins);
    return allPlugins;
}
export default withPlugins;
